// composables/useHydratedHeaders.ts
import { computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useRoute } from 'vue-router';

export function useHydratedHeaders(moduleName?: string) {
  const preferencesStore = usePreferencesStore();
  const route = useRoute();

  const resolvedModule = computed(() => {
    return moduleName ?? preferencesStore.currentModule ?? (route.meta.moduleName ?? route.name) as string;
  });

  return computed(() => {
    const all = preferencesStore.allModuleHeaders;
    const def = preferencesStore.defaultModuleHeaders;
    const values = preferencesStore.preferences?.[resolvedModule.value]?.headers?.data ?? [];

    const hydrated = values.length > 0
      ? values.map(v => all.find(h => h.value === v)).filter(Boolean)
      : def;

    return [
      ...hydrated,
      { value: 'actions', sortable: false, align: 'end' },
    ];
  });
}
